import { ExclamationCircleFilled, InfoCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { FC } from 'react';

import styles from './styles.module.scss';

type TooltipType = 'info' | 'warning' | 'error';

type PropTypes = {
  type?: TooltipType;
  text?: string;
  className?: string;
  hidden?: boolean;
};

type IconConfig = {
  style: string;
  icon: any;
};

const iconConfigs: Record<TooltipType, IconConfig> = {
  info: { style: styles.info, icon: InfoCircleFilled },
  warning: { style: styles.warning, icon: ExclamationCircleFilled },
  error: { style: styles.error, icon: ExclamationCircleFilled },
};

export const IconTooltip: FC<PropTypes> = ({
  type = 'info',
  text,
  className = '',
  hidden = false,
}) => {
  const { icon: Icon, style } = iconConfigs[type];
  const styleHidden = hidden ? styles.hidden : '';
  const mergedTooltipStyle = `${styles.tooltip} ${styleHidden} ${className}`;
  return (
    <Tooltip title={text ?? type} className={mergedTooltipStyle}>
      <Icon className={style} />
    </Tooltip>
  );
};
